import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import moment from 'moment';


export default class CatalogChatService {
    static $inject = [ '$http', 'cartonomyConfig', 'Message', 'Session', 'LocalForageService', '$rootScope', 'RealTimeUpdateService' ];

    constructor(httpService, cartonomyConfig, messageService, sessionService, localForageService, rootScope, RealTimeUpdateService) {

        this._httpService = httpService;
        this._sessionService = sessionService;
        //this._sessionStorageService = sessionStorageService;
        this._localForageService = localForageService;
        this._urlBase = cartonomyConfig.ApiV2 + 'cartpost';
        this._postList = [];
        this._rootScope = rootScope;
        this._messageService = messageService;
        this._cartonomyConfig = cartonomyConfig;
        this._chatFailRetries = 0;

        this._refreshing = false;

        this.chatActive = false;

        this.realtimeUpdateService = RealTimeUpdateService;

        this.refreshing = () => this._refreshing;

        this._unreadMessages = this.getUnreadMessages();

        rootScope.$on(Constants.Events.WINDOW_STATE_CHANGED, async (scope, state) => {
            if (state === Constants.WindowMode.minimized) {
                await this.startWatchingOnUnreadMessage();
            }
        });

        rootScope.$on(Constants.Events.REALTIME_CHAT_RECEIVED, async (scope, messageObj) => this._onChatMessageReceived(messageObj));
    }

    async postMessage(message) {
        if (!(await this._sessionService.loggedIn())) {
            return;
        }

        if (!this.realtimeUpdateService.instance) {
            await this.realtimeUpdateService.ensureConnected();
        }

        try {
            let cart = await this._sessionService.getCartReference();
            let cartId
            if(cart)
            {
                cartId = cart.id
            }
            let res = await this._httpService.post(this._urlBase, {message, cartId: cartId});
            this._chatFailRetries = 0;
            return res;
        } catch (error) {
            this._chatFailRetries++;
            if (this._chatFailRetries === 5) {
                //await this._messageService.showErrorPopup('Oops!  Your chat session is having trouble communicating
                // with the server. Please press OK so that the application can re-load.');
                this._chatFailRetries = 0;
                location.reload(true);
                return;
            }
            this.realtimeUpdateService.resetConnection();
            return await this.postMessage(message);
        }
    }

    reset() {
        this._postList = [];
    }

    async stopWatchingForUnreadMessage() {
        await this._localForageService.remove(Constants.SessionStorage.UnreadChatMessages);
        this._unreadMessages = undefined;
        this.chatActive = true;

        await this._localForageService.remove(Constants.SessionStorage.UnreadChatMessages);
        this._rootScope.$broadcast(Constants.Events.CHAT_MESSAGE_RECEIVED, this._unreadMessages);
    }

    async startWatchingOnUnreadMessage() {
        this._unreadMessages = await this._localForageService.retrieve(Constants.SessionStorage.UnreadChatMessages) || 0;
        this.chatActive = false;
    }

    async update() {
        if (!(await this._sessionService.loggedIn())) {
            this.reset();
            return;
        }

        let response = await this._httpService.get(this._urlBase);

        this.reset();
        this._onResponseReceived(response.data);
        return this._postList;
    }

    async updateByCartId(cartId) {
        if (!(await this._sessionService.loggedIn())) {
            this.reset();
            return;
        }

        let response = await this._httpService.get(this._urlBase + '/' + cartId);

        this.reset();
        this._onResponseReceived(response.data);
        return this._postList;
    }

    _handleCartPostDetails(post) {
        post.id = post.id || post.Id;
        post.createdOn = moment.utc(post.createdOn).toDate();
        this._postList.push(post);
    }

    _onResponseReceived(data) {
        if (!data || !data.length) {
            return;
        }

        _.each(data, post => this._handleCartPostDetails(post));
    }

    async getMessages() {
        return new Promise((resolve, reject) => {
            const _this = this;
            function checkAndReturnMessageList() {
                if (_this.lockMsgList) {
                    setTimeout(() => checkAndReturnMessageList(), 1);
                    return;
                }
                resolve(_this._postList);
            }

            checkAndReturnMessageList();
        });
    }

    async notifyUnreadMessageIfNeeded(playSound = false) {
        if (!this.chatActive) {
            if (playSound) {
                new Audio(Constants.Notifications.chatNotification).play();
            }
            if (this._unreadMessages === undefined)
                this._unreadMessages = 0;

            this._unreadMessages++;
            await this._localForageService.store(Constants.SessionStorage.UnreadChatMessages, this._unreadMessages);
            this._rootScope.$broadcast(Constants.Events.CHAT_MESSAGE_RECEIVED, this._unreadMessages);
        }
    }

    async getUnreadMessages() {
        return await this._localForageService.retrieve(Constants.SessionStorage.UnreadChatMessages) || undefined;
    }

    async _onChatMessageReceived(messageObj) {
        this.lockMsgList = true;
        let cart = await this._sessionService.getCartReference();
        if(!cart && this._postList.length > 0)
            cart = {id: this._postList[0].cartId};
        
        if(cart && cart.id === messageObj.cartId)
        {
            let existingChatMsg = _.find(this._postList, post => post.id === messageObj.id || post.id === messageObj.Id);
            if (existingChatMsg) {
                this._postList = _.without(this._postList, existingChatMsg);
            }
    
            let currentLoggedInUser = this._sessionService.getUserEmail();
            this._handleCartPostDetails(messageObj);
    
            let playSound = false;
            if (messageObj.Email !== currentLoggedInUser && !messageObj.IsOwner) {
                playSound = true;
            }
            this.notifyUnreadMessageIfNeeded(playSound);
        } else {
            let currentLoggedInUser = await this._sessionService.getUserEmail();

            let playSound = false;
            if (messageObj.Email !== currentLoggedInUser && !messageObj.IsOwner) {
                playSound = true;
            }
            await this.notifyUnreadMessageIfNeeded(playSound);
        }
        this.lockMsgList = false;
    }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/services/ChatService.js